"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisaBrandingResourceUrlEnum = void 0;
/**
 * VisaBrandingResourceUrlEnum enum file
 */
var VisaBrandingResourceUrlEnum;
(function (VisaBrandingResourceUrlEnum) {
    VisaBrandingResourceUrlEnum["DEV"] = "https://kushki-static-dev.s3.amazonaws.com/visa-sensory-branding/v2";
    VisaBrandingResourceUrlEnum["PROD"] = "https://kushki-static.s3.amazonaws.com/visa-sensory-branding/v2";
})(VisaBrandingResourceUrlEnum = exports.VisaBrandingResourceUrlEnum || (exports.VisaBrandingResourceUrlEnum = {}));
